module.exports = __webpack_public_path__ + "static/media/delivery_bee.8df92938.png";